import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import BlurModal from '../blurModal/BlurModal';
import { s } from '../../app/helper';
import LoadingModal from '../loadingModal/LoadingModal';
import styles from './UploadDocument.module.css';
import UploadForm from './UploadForm';

type UploadDocumentProps = {
  showUploadDocument: boolean;
  onHide: () => void;
};

const UploadDocument: React.FC<UploadDocumentProps> = ({ showUploadDocument, onHide }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [uploadingReport, setUploadingReport] = useState<boolean>(false);
  // TODO: is the LoadingModal needed?
  return (
    <BlurModal
      show={showUploadDocument}
      onHide={onHide}
      backdropClassName={styles.uploadModalBackdrop}
    >
      <div className={s(styles.uploadModal)}>
        <Container className={s(styles.uploadModalContents)}>
          {
            uploadingReport ? (
              <p>
                <LoadingModal show />
              </p>
            ) : <UploadForm onHide={onHide} />
          }
        </Container>
      </div>
    </BlurModal>
  );
};

export default UploadDocument;
